import { render, staticRenderFns } from "./envInfoItem.vue?vue&type=template&id=4a2bc60b&scoped=true&"
import script from "./envInfoItem.vue?vue&type=script&lang=js&"
export * from "./envInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./envInfoItem.vue?vue&type=style&index=0&id=4a2bc60b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2bc60b",
  null
  
)

export default component.exports